<template>
  <div id="app-wrapper">
    <SideBar />
    <TopBar />

    <main id="main" class="w-full flex overflow-hidden">
      <router-view />
    </main>
  </div>
</template>
<script lang="ts" setup>
import TopBar from "layout/TopBar.vue";
import SideBar from "layout/SideBar.vue";
</script>
